var map;
var markers = {};
var listOfMarkers = new Array();
var numberOfMarkers;
var markersInCluster = {};
var numberMarkersInCluster;
var zoomBounds = new Array();
var zoomToItem = new Array();
var osmStandardLayer;

// Extending MarkerCluster to add some padding for showing the headlines.
// It works fine for big viewports but when the display is small there is a chance that the cluster won't expand
// when clicked or touched because there is not enough space to add the padding
var windowWidth = $(window).width();
var windowHeight = $(window).height();
if (windowWidth > 672 && windowHeight > 480) {
	L.MarkerCluster = L.MarkerCluster.extend({
		//Zoom to the extents of this cluster but adding padding to fit the popup (headline) inside the viewport
		zoomToBounds: function () {
			this._group._map.fitBounds(this._bounds,{paddingTopLeft: [30,50], paddingBottomRight: [30,10]});
		}
	});
}

var smallIcon = new SmallIcon();

$(document).ready(function() {
	loadMap();
});

function loadMap() {
	
	var mapDiv = $('#map');

	// map height < small viewport height
	forceMapHeightFitSmallViewPort(mapDiv);
	$(window).resize(function() {
			forceMapHeightFitSmallViewPort(mapDiv);
	});

	initWizard();

	var iTotalElements = $('span.locInfo').length;

	var fTempLat = 200.0;
	var fTempLon = 200.0;
	var bAllSameCoords = false;

	$('span.locInfo').each(function(index) {

		// get all data attributes from this item at once
		var info = $(this).data();

		// the data-attributes were not set
		if (typeof info['article.article_id'] == 'undefined') {
			return 'continue';
		}

		var id    = info['article.article_id'];
		var title = info['article.cache_header'];
		var lat   = info['location.lat'];
		var lon   = info['location.lon'];
		var link  = '/?i=' + id + '&lp';
		
		// skip if important data is missing
		if (id == '' || title == '' || lat == '' || lon == '') {
			return 'continue';
		}

		var fLat = parseFloat(lat);
		var fLon = parseFloat(lon);

		if (fLat == fTempLat && fLon == fTempLon) {
			bAllSameCoords = true;
		} else {
			bAllSameCoords = false;
		}

		fTempLat = fLat;
		fTempLon = fLon;

		if ( info['location.bbleft']!='' && info['location.bbtop']!='' &&
		     info['location.bbright']!='' && info['location.bbbottom']!='' ) {

			var fBoxLeft = parseFloat(info['location.bbleft']);     //w
			var fBoxTop = parseFloat(info['location.bbtop']);       //n
			var fBoxRight = parseFloat(info['location.bbright']);   //e
			var fBoxBottom = parseFloat(info['location.bbbottom']); //s

			if ( iTotalElements == 1 || (index === iTotalElements && bAllSameCoords) ) {
				zoomBounds.push([fBoxBottom, fBoxLeft]);
				zoomBounds.push([fBoxTop, fBoxRight]);
			}

			zoomToItem[id] = [[fBoxBottom, fBoxLeft],[fBoxTop, fBoxRight]];

		} else {

			zoomToItem[id] = [fLat, fLon];

		}
		
		title = wrapTitle(title);
				
		///DOM element for popup
		var domElem = document.createElement('a');
		domElem.href = link;
		domElem.innerHTML = title;

		//structured data
		title = "<div itemscope itemtype='http://schema.org/NewsArticle'>" +
		        "<div itemprop  itemtype='http://schema.org/headline'>" +
		        title +
		        "</div>" +
		        "</div>";


		// marker
		marker = L.marker([fLat,fLon], {icon: smallIcon, markerID: id});
		marker.bindPopup(domElem,
		                {
		                    maxWidth: 500,
		                    autoPan: false,
		                    autoClose: false,
		                    closeButton: false,
		                    closeOnClick: false
		                }
		);
		listOfMarkers.push(marker);

		// make sure the lat and lon of the marker are included
		zoomBounds.push([fLat, fLon]);
	});
			
	numberOfMarkers = listOfMarkers.length;

	// add markers to cluster group
	markers.addLayers(listOfMarkers);

	// add cluster group to map
	map.addLayer(markers);

	if (zoomBounds.length !== 0 && (iTotalElements == 1 || bAllSameCoords || iTotalElements > 20)) {
		map.fitBounds(zoomBounds);
	} else if (zoomBounds.length !== 0) {
		//Adding padding to fit the popup (headline) inside the viewport
		map.fitBounds(zoomBounds,{paddingTopLeft: [30,50], paddingBottomRight: [30,10]});
	} else {
		zoomBounds.push([70, -100]);
		zoomBounds.push([0, 100]);
		map.fitBounds(zoomBounds);
	}

	// all headlines must be visible
	// queue the code to run once the current call stack is finished executing -> wait for the font to load, otherwise
	// the popup size is not accurate
	setTimeout(function() {
		openAllPopups();
	},0);

}


function initWizard() {

	var attributionText = "<a href='/copyright?map'>&#169;</a>";
	
	osmStandardLayer = L.tileLayer('https://osm-{s}.ii.nl/osm_tiles/{z}/{x}/{y}.png',
	                       {
	                            minZoom: 1,
	                            maxZoom: 18,
	                            attribution: attributionText
	                        });

	map = L.map('map', {
	            maxBounds:[[-70, -260],[88, 260]],
	            minZoom: 1,
	            maxZoom: 18,
	            scrollWheelZoom: false,
	            layers: [osmStandardLayer]
	});


	map.attributionControl.setPrefix('');

	markers = L.markerClusterGroup({
	                                spiderfyDistanceMultiplier:4,
	                                maxClusterRadius:50,
	                                removeOutsideVisibleBounds:false
	                               });
	
	// Make sure the popups are always visible
	map.on('moveend', openAllPopups); //fired when the view of the map stops changing e.g. user stopped dragging the map
	markers.on('spiderfied', openAllPopups); //fired when a cluster is clicked and its markers have the same coordinates

	// add terminator
	var t = L.terminator({fillOpacity: 0.08});
	t.addTo(map);

	// update terminator every 5 seconds
	setInterval(function(){updateTerminator(t)}, 5000);
	
	function updateTerminator(t) {
		var t2 = L.terminator();
		t.setLatLngs(t2.getLatLngs());
		t.redraw();
	}

	// For mobile:
	// enables/disables interaction with map when user taps on the map. This avoids interference with page scrolling
	// L.Browser.touch: true for all browsers on touch devices
	// L.Browser.mobile: true for modern mobile browsers
	if (L.Browser.mobile) {
		map.dragging.disable();
		map.touchZoom.disable();
		if (map.tap) {
			map.tap.disable();
		}

		$('.leaflet-control-zoom').toggle();

		// event listener function
		map.on('click', onTapEnableInteraction); 
	}

}


// Forcing the height of the map to always fit when viewport is too small (when media queries are not enough)
// There must be space for the user to start scrolling the page. 180pxs are enough.
// Current map height for displays of max-width:42em is 200px (media query)
// Current max height for the map for greater viewports is 384px
function forceMapHeightFitSmallViewPort(div) {

	var minimumMapFreeSpace = 180;
	var mapHeight = div.height();
	var windowHeight = $( window ).height();

	var maxHeight = windowHeight - minimumMapFreeSpace;

	// reduce height when required
	if ( mapHeight > maxHeight && maxHeight < 200 ) {
		div.css('height', maxHeight);
	// increase height when required
	} else if ( mapHeight < 200 && maxHeight < 200 ) {
		div.css('height', maxHeight);
	// allow the media queries to set the height again
	} else if ( maxHeight > 200 ) {
		div.css('height', '');
	}

}

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
